import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {Box, SxProps, Theme} from "@mui/material";
import React from "react";
import type {DraggableProvidedDragHandleProps} from "react-beautiful-dnd";

function DragIndicator(props: {
	dragHandleProps?: DraggableProvidedDragHandleProps | null;
	className?: string;
	sx?: SxProps<Theme>;
}) {
	return (
		<Box
			className={props.className}
			component="span"
			{...props.dragHandleProps}
			sx={[
				{display: "flex"},
				...(Array.isArray(props.sx) ? props.sx : [props.sx]),
			]}
		>
			<DragIndicatorIcon
				sx={{color: (theme) => theme.palette.text.secondary}}
			/>
		</Box>
	);
}

export default DragIndicator;
